import React, { useState } from 'react';
import { COSMETICS, GADGETS, PETS, TRAILS, AURAS, SKINS } from '../game/config';

// Mystery Vault — spend a Keycard (earned every match) to smash open a random reward.
const POOLS = [
  ['skins', SKINS, 'skin'], ['hats', COSMETICS.hats.reduce((o, i) => (o[i.id] = i, o), {}), 'hat'],
  ['trails', TRAILS, 'trail'], ['auras', AURAS, 'aura'], ['effects', COSMETICS.effects.reduce((o, i) => (o[i.id] = i, o), {}), 'effect'],
  ['gadgets', GADGETS, 'gadget'], ['pets', PETS, 'pet'],
];

export default function Vault({ profile, onChange, onClose }) {
  const [spinning, setSpinning] = useState(false);
  const [reward, setReward] = useState(null);

  const open = () => {
    if ((profile.keys || 0) < 1 || spinning) return;
    setSpinning(true); setReward(null);
    // collect all unowned items
    const owned = profile.owned || {};
    const unowned = [];
    for (const [cat, obj, field] of POOLS) {
      for (const [id, v] of Object.entries(obj)) {
        if (id === 'none' || (v.price || 0) === 0) continue;
        if (!(owned[cat] || []).includes(id)) unowned.push({ cat, id, field, item: v });
      }
    }
    setTimeout(() => {
      let rw;
      if (unowned.length && Math.random() < 0.45) {
        const pick = unowned[Math.floor(Math.random() * unowned.length)];
        const nextOwned = { ...owned, [pick.cat]: [...(owned[pick.cat] || []), pick.id] };
        onChange({ keys: profile.keys - 1, owned: nextOwned, [pick.field]: pick.id });
        rw = { type: 'item', icon: pick.item.icon, name: pick.item.name };
      } else {
        const coins = [150, 250, 400, 600, 900][Math.floor(Math.random() * 5)];
        onChange({ keys: profile.keys - 1, coins: (profile.coins || 0) + coins });
        rw = { type: 'coins', icon: '🪙', name: '+' + coins + ' coins' };
      }
      setReward(rw); setSpinning(false);
    }, 1400);
  };

  return (
    <div className="so-overlay" onClick={onClose} data-testid="vault-modal">
      <div className="so-panel" onClick={(e) => e.stopPropagation()} style={{ textAlign: 'center' }}>
        <button className="so-panel-x" onClick={onClose} data-testid="vault-close">✕</button>
        <h2>🔐 Mystery Vault</h2>
        <p className="so-store-sub">Earn a 🔑 Keycard every match. Smash a vault for a random skin, gadget, pet or coins!</p>
        <div className={'so-vault-machine' + (spinning ? ' spinning' : '')} data-testid="vault-machine">
          {reward ? <div className="so-vault-reward" data-testid="vault-reward"><span>{reward.icon}</span><b>{reward.name}</b></div>
            : <span className="so-vault-q">{spinning ? '🎰' : '❓'}</span>}
        </div>
        <div className="so-vault-keys">🔑 Keycards: <b data-testid="vault-keys">{profile.keys || 0}</b></div>
        <button className="so-btn-play" onClick={open} disabled={(profile.keys || 0) < 1 || spinning} data-testid="vault-open">
          {spinning ? 'Smashing…' : 'Open Vault (1 🔑)'}
        </button>
      </div>
    </div>
  );
}
